"use client";

import { Building } from "lucide-react";
import { useEffect, useRef, useState } from "react";

const VillageMap = ({ data }) => {
  const mapRef = useRef(null);
  const [mapInstance, setMapInstance] = useState(null);
  const [infoWindow, setInfoWindow] = useState(null);
  const themes = localStorage.getItem("themes");

  let mapStyle = [];
  if (themes && themes === "darkMode") {
    mapStyle = [
      {
        elementType: "geometry",
        stylers: [{ color: "#1a2332" }],
      },
      {
        elementType: "labels.text.fill",
        stylers: [{ color: "#ffffff" }],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [{ color: "#1a2332" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#4a6fa5" }, { lightness: -10 }],
      },
      {
        featureType: "administrative.land_parcel",
        elementType: "labels.text.fill",
        stylers: [{ color: "#64779f" }],
      },
      {
        featureType: "administrative.province",
        elementType: "geometry.stroke",
        stylers: [{ color: "#4a6fa5" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#263238" }],
      },
      {
        featureType: "landscape.man_made",
        elementType: "geometry.stroke",
        stylers: [{ color: "#334e87" }],
      },
      {
        featureType: "landscape.natural",
        elementType: "geometry",
        stylers: [{ color: "#263238" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#283d6a" }],
      },
      {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{ color: "#6f9ba4" }],
      },
      {
        featureType: "poi",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#1d2c4d" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry.fill",
        stylers: [{ color: "#023e58" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [{ color: "#3C7680" }],
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#304a7d" }],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ color: "#98a5be" }],
      },
      {
        featureType: "road",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#1d2c4d" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#2c6675" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#255763" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ color: "#b0d5ce" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#023e58" }],
      },
      {
        featureType: "transit",
        elementType: "labels.text.fill",
        stylers: [{ color: "#98a5be" }],
      },
      {
        featureType: "transit",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#1d2c4d" }],
      },
      {
        featureType: "transit.line",
        elementType: "geometry.fill",
        stylers: [{ color: "#283d6a" }],
      },
      {
        featureType: "transit.station.bus",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit.station.rail",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit.station.metro",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit.station",
        elementType: "geometry",
        stylers: [{ color: "#3a4762" }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#0e1626" }],
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#4e6d70" }],
      },
    ];
  } else {
    mapStyle = [
      {
        elementType: "geometry",
        stylers: [{ color: "#f1f5f9" }],
      },
      {
        elementType: "labels.text.fill",
        stylers: [{ color: "#1e293b" }],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [{ color: "#ffffff" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#94a3b8" }],
      },
      {
        featureType: "administrative.land_parcel",
        elementType: "labels.text.fill",
        stylers: [{ color: "#475569" }],
      },
      {
        featureType: "administrative.province",
        elementType: "geometry.stroke",
        stylers: [{ color: "#64748b" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#e2e8f0" }],
      },
      {
        featureType: "landscape.man_made",
        elementType: "geometry.stroke",
        stylers: [{ color: "#cbd5e1" }],
      },
      {
        featureType: "landscape.natural",
        elementType: "geometry",
        stylers: [{ color: "#f1f5f9" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#bae6fd" }],
      },
      {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{ color: "#0c4a6e" }],
      },
      {
        featureType: "poi",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#ffffff" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry.fill",
        stylers: [{ color: "#bbf7d0" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [{ color: "#14532d" }],
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#f8fafc" }],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ color: "#334155" }],
      },
      {
        featureType: "road",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#ffffff" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#93c5fd" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#60a5fa" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ color: "#1e40af" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#ffffff" }],
      },
      {
        featureType: "transit",
        elementType: "labels.text.fill",
        stylers: [{ color: "#64748b" }],
      },
      {
        featureType: "transit",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#ffffff" }],
      },
      {
        featureType: "transit.line",
        elementType: "geometry.fill",
        stylers: [{ color: "#bae6fd" }],
      },
      {
        featureType: "transit.station",
        elementType: "geometry",
        stylers: [{ color: "#e0f2fe" }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#60a5fa" }],
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#1d4ed8" }],
      },
    ];
  }

  // Custom marker SVG based on the provided design
  const createCustomMarker = () => {
    return {
      url:
        "data:image/svg+xml;charset=UTF-8," +
        encodeURIComponent(`
        <svg width="32" height="45" viewBox="0 0 32 45" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="redGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#ff4444;stop-opacity:1" />
              <stop offset="100%" style="stop-color:#cc2222;stop-opacity:1" />
            </linearGradient>
            <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
              <feDropShadow dx="2" dy="2" stdDeviation="2" floodColor="#000000" floodOpacity="0.3"/>
            </filter>
          </defs>
          <circle cx="16" cy="16" r="10" fill="url(#redGradient)" filter="url(#shadow)"/>
          <rect x="15" y="28" width="4" height="35" fill="#7dd3fc" rx="2"/>
          <circle cx="10" cy="10" r="6" fill="#ffffff" opacity="0.3"/>
        </svg>
      `),
      scaledSize: new window.google.maps.Size(24, 34),
      anchor: new window.google.maps.Point(12, 34),
    };
  };

  // Enhanced info window content
  const createInfoWindowContent = (village) => {
    const resolvedPercentage =
      village.totalGrievances > 0
        ? Math.round(
            (village.resolvedGrievances / village.totalGrievances) * 100
          )
        : 0;

    return `
      <div style="
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        padding: 16px;
        min-width: 150px;
        background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
        border-radius: 12px;
        color: white;
        box-shadow: 0 10px 25px rgba(0,0,0,0.3);
      ">
        <div style="
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          padding-bottom: 8px;
          border-bottom: 1px solid rgba(255,255,255,0.1);
        ">
          <div style="
            width: 8px;
            height: 8px;
            background: #ef4444;
            border-radius: 50%;
            margin-right: 8px;
          "></div>
          <h3 style="
            margin: 0;
            font-size: 18px;
            font-weight: 600;
            color: #f8fafc;
          ">${village.villageName}</h3>
        </div>
        
        <div style="margin-bottom: 16px;">
          <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
          ">
            <span style="color: #cbd5e1; font-size: 14px;">Total Grievances</span>
            <span style="
              background: #3b82f6;
              color: white;
              padding: 4px 12px;
              border-radius: 20px;
              font-weight: 600;
              font-size: 14px;
            ">${village.totalGrievances}</span>
          </div>
          
          <div style="
            background: rgba(255,255,255,0.1);
            border-radius: 8px;
            padding: 12px;
            margin-top: 12px;
          ">
            <div style="
              display: flex;
              justify-content: space-between;
              margin-bottom: 8px;
            ">
              <div style="display: flex; align-items: center;">
                <div style="
                  width: 12px;
                  height: 12px;
                  background: #10b981;
                  border-radius: 50%;
                  margin-right: 8px;
                "></div>
                <span style="color: #e2e8f0; font-size: 14px;">Resolved</span>
              </div>
              <span style="color: #10b981; font-weight: 600;">${
                village.resolvedGrievances
              }</span>
            </div>
            
            <div style="
              display: flex;
              justify-content: space-between;
              margin-bottom: 8px;
            ">
              <div style="display: flex; align-items: center;">
                <div style="
                  width: 12px;
                  height: 12px;
                  background: #f59e0b;
                  border-radius: 50%;
                  margin-right: 8px;
                "></div>
                <span style="color: #e2e8f0; font-size: 14px;">In Progress</span>
              </div>
              <span style="color: #f59e0b; font-weight: 600;">${
                village.inProgressGrievances
              }</span>
            </div>
            
            <div style="
              margin-top: 12px;
              padding-top: 8px;
              border-top: 1px solid rgba(255,255,255,0.1);
            ">
              <div style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              ">
                <span style="color: #cbd5e1; font-size: 12px;">Resolution Rate</span>
                <span style="
                  color: ${
                    resolvedPercentage >= 70
                      ? "#10b981"
                      : resolvedPercentage >= 40
                      ? "#f59e0b"
                      : "#ef4444"
                  };
                  font-weight: 600;
                  font-size: 14px;
                ">${resolvedPercentage}%</span>
              </div>
              <div style="
                width: 100%;
                height: 4px;
                background: rgba(255,255,255,0.1);
                border-radius: 2px;
                margin-top: 4px;
                overflow: hidden;
              ">
                <div style="
                  width: ${resolvedPercentage}%;
                  height: 100%;
                  background: ${
                    resolvedPercentage >= 70
                      ? "#10b981"
                      : resolvedPercentage >= 40
                      ? "#f59e0b"
                      : "#ef4444"
                  };
                  transition: width 0.3s ease;
                "></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  };

  useEffect(() => {
    if (window.google && mapRef.current) {
      const bounds = new window.google.maps.LatLngBounds();

      const map = new window.google.maps.Map(mapRef.current, {
        center: {
          lat: Number.parseFloat(data[0]?.lattitude) || 28.04,
          lng: Number.parseFloat(data[0]?.longitude) || 79.13,
        },
        zoom: 8,
        styles: mapStyle,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        zoomControl: true,
        zoomControlOptions: {
          position: window.google.maps.ControlPosition.RIGHT_CENTER,
        },
      });

      setMapInstance(map);

      const iw = new window.google.maps.InfoWindow({
        maxWidth: 320,
        pixelOffset: new window.google.maps.Size(0, -10),
      });
      setInfoWindow(iw);

      data.forEach((village) => {
        if (village.lattitude && village.longitude) {
          const position = {
            lat: Number.parseFloat(village.lattitude),
            lng: Number.parseFloat(village.longitude),
          };

          bounds.extend(position);

          const marker = new window.google.maps.Marker({
            position,
            map,
            title: village.villageName,
            icon: createCustomMarker(),
          });

          marker.addListener("click", () => {
            iw.setContent(createInfoWindowContent(village));
            iw.open(map, marker);
          });
        }
      });

      map.fitBounds(bounds);
    }
  }, [data]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-1 h-full insights-card p-4 rounded-xl border border-gray-200">
      <div>
        <h3 className="text-sm font-bold text-color mb-3 flex items-center gap-2">
          <Building size={16} className="text-orange-600" />
          Ward-wise Distribution
        </h3>
        <div
          ref={mapRef}
          style={{ width: "100%", height: "95%" }}
          className="rounded-xl overflow-hidden border"
        />
      </div>

      {/* <div>
        <h3 className="text-xl font-bold text-gray-900 mb-6">Village Statistics</h3>
        <div className="space-y-4 max-h-90 overflow-y-auto">
          {data.map((village) => (
            <div
              key={village.villageId}
              className="bg-white rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow"
            >
              <div className="flex items-center justify-between mb-3">
                <h4 className="font-semibold text-gray-900">{village.villageName}</h4>
                <span className="bg-blue-100 text-blue-800 text-sm font-medium px-3 py-1 rounded-full">
                  {village.totalGrievances} total
                </span>
              </div>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  <span className="text-gray-600">Resolved: {village.resolvedGrievances}</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-600">In Progress: {village.inProgressGrievances}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default VillageMap;
